import { formatDateTime, ItemListContent, userInteraction } from "@eusoft/webapp-framework";
import { FieldSearchMode, FilterEditor } from "@eusoft/webapp-framework/components/FilterEditor";
import { arrayItemsSource, formatText, MaterialIcon } from "@eusoft/webapp-ui";
import { SortDirection, type IListDevice, type IListSession, type ISessionListView } from "../../entities/Commands";
import { Icons } from "../../entities/Icons";
import { entityItemsSource } from "../../helpers/ItemsSources";
import { Authorize } from "../../services/Authorize";
import { executeAsync } from "../../services/DataService";
import { userSession } from "../../services/UserSession";

export interface IListSessionArgs {
}



const listOrderFilter = () => new FilterEditor<IListSession, ISessionListView>({
    fields: {
    
        deviceId: {
            label: "device",
            color: "#9C27B0", // purple 500
            valuesSource: entityItemsSource("ListDevice"),
            searchMode: FieldSearchMode.Client,
            icon: Icons["device"],
            valuesFilter: a => ({

            } as Partial<IListDevice>)
        },
        browser: {
            label: "browser",
            color: "#2196F3", // blue 500
            valuesSource: arrayItemsSource(["Chrome", "App", "Firefox", "Safari", "Edge"], a=> a),
            searchMode: FieldSearchMode.Client,
            icon: <MaterialIcon name="language"/>
        },
        os: {
            label: "os",
            color: "#4CAF50", // green 500
            valuesSource: arrayItemsSource(["Android", "Windows"], a => a),
            searchMode: FieldSearchMode.Client,
            icon: <MaterialIcon name="computer" />
        },
    },
    renderMode: "field",
    queryField: "name"
});

async function deleteSessionAsync(item: ISessionListView) {

    const result = await executeAsync("CloseSession", {
        sessionId: item.id
    });

    if (result)
        userInteraction.messageAsync(formatText("session-closed"), "success", 3000);

    return true;
}

export const ListSessionPage = ItemListContent.builder<ISessionListView, IListSession>()

    .info({
        name: "session-list",
        route: "/sessions",
        icon: <MaterialIcon name="remember_me" />,
    })

    .feature(Authorize(bld => bld.resource("UserSession", "list")))

    .options({
        title: "session-list",
        route: "/sessions",
        style: ["panel", "round-item"],
        itemsSource: entityItemsSource("ListSession"),
        prepareFilter: (filter, offset, limit) => ({
            ...filter,
            onlyActive: true,
            pagination: {
                offset,
                limit
            },
            sort: {
                property: "LastAccessTime",
                direction: SortDirection.Descending
            }
        }),
        itemView: {
            maxActions: 1
        },
        filterEditor: listOrderFilter,
        pageSize: 30,
        paginationMode: "manual",
        canDelete: item => item?.id != userSession.active.sessionId,
        deleteItemAsync: item => deleteSessionAsync(item),    
        columns: [{
            value: a => {
                const time = formatDateTime(a.lastAccessTime);
                if (a.id == userSession.active.sessionId)
                    return <>{time}<strong> ({formatText("current")})</strong></>
                return time;
            },
            priority: "primary",
            header: "last-access",
        },
        {
            value: a => a.userAgentInfo.os + " " + a.userAgentInfo.osVersion,
            priority: "secondary",
            header: "os",
        },
        {
            value: a => a.userAgentInfo?.browser, 
            priority: "secondary",
            header: "browser",
        },
        {
            value: a => a.webVersion?.environment,
            priority: "secondary",
            header: "environment",
        },

        {
            value: a => a.nativeVersion?.versionName,
            priority: "secondary",
            header: "last-access",
        }],
        filterMode: "tags"

    }).asContent();